import { useTheme } from "@mui/material"


export const useStyles = () => {
    const { palette } = useTheme()
    return {
        container: {
            position: 'relative',
            width: '10px',
            height: '10px',
            justifyItems: 'center'
        },
        mark: {
            position: 'absolute',
            justifyItems: 'center',
            top: '-85px', left: '50%',
            transform: 'translateX(-50%)'
        },
        header: (color:string) => ({
            fontSize: '12px',
            backgroundColor: color,
            color: 'white',
            width: 'fit-content',
            padding: '2px 6px',
            borderRadius: '4px',
            whiteSpace: 'nowrap',
            marginBottom: '5px'
        }),
        containerMark: {
            position: 'relative'
        },
        user: {
            fontSize: '12px',
            backgroundColor: 'white',
            position: 'absolute',
            right: '-40px',
            padding: '4px',
            borderRadius: '4px'
        }
    }
}